import React, {
  Fragment,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { Alert, Card, CardBody, Col, FormGroup, Label, Row } from "reactstrap";

import { H3 } from "../../../../AbstractElements";
import { useTranslation } from "react-i18next";
import { ContactContext, ContactDataContext } from "../../ContextProvider";
import InputError from "../../../../Shared/Components/Form/InputError";

const ContactData = ({ contactId, register, errors, reset, setValue }) => {
  const { t } = useTranslation("translation");
  const refSubmitButtom = useRef();
  //context
  const {
    item: contactData,
    created,
    dispatchSaveButton,
    successUpdated,
  } = useContext(ContactContext);
  const { item, apiErrors, setApiErrors, setItem, getItem } =
    useContext(ContactDataContext);

  //alert
  const [alertOpen, setAlertOpen] = useState(
    apiErrors && apiErrors.length > 0 ? true : false
  );

  const ToggleAlert = () => setAlertOpen(!alertOpen);

  //usefect
  useEffect(() => {
    setAlertOpen(apiErrors && apiErrors.length > 0 ? true : false);
  }, [apiErrors]);

  useEffect(() => {
    setValue("contact_id", contactData?.id);
    setValue("email_1", item?.email_1);
    setValue("email_2", item?.email_2);
    setValue("email_3", item?.email_3);
    setValue("whatsapp_1", item?.whatsapp_1);
    setValue("whatsapp_2", item?.whatsapp_2);
    setValue("whatsapp_3", item?.whatsapp_3);
  }, [item]);

  useEffect(() => {
    contactId ? getItem(contactId) : setItem({});
  }, [contactId]);

  useEffect(() => {
    setValue("contact_id", contactData?.id);
  }, [contactData]);

  useEffect(() => {
    return () => {
      setItem({});
      setApiErrors([]);
    };
  }, []);
  return (
    <Fragment>
      <Card>
        <CardBody>
          <Alert
            className="alert-dismissible"
            color="danger inverse"
            isOpen={alertOpen}
            toggle={ToggleAlert}
          >
            <i class="icon-alert"></i>
            {apiErrors && apiErrors.length > 0 ? apiErrors[0] : ""}
          </Alert>

          <H3>Datos de contacto</H3>

          <div className="product-info">
            <div className="product-group mb-3">
              <Row>
                <Col lg="6">
                  <FormGroup>
                    <Label> {t("Whatsapp 1")}</Label>
                    <input
                      className={`form-control ${
                        errors.whatsapp_1 && "is-invalid"
                      }`}
                      type="text"
                      placeholder="54 9 11 1234-5678"
                      name="whatsapp_1"
                      {...register("whatsapp_1", {
                        pattern: {
                          value: /^\d{1,3}\d{9,13}$/,
                          message:
                            "El whatsapp debe contener solo numeros y debe contener entre 10 y 13 caracteres",
                        },
                      })}
                    />
                    <InputError errors={errors} name="whatsapp_1" />
                  </FormGroup>
                </Col>
                <Col lg="6">
                  <FormGroup>
                    <Label> {t("Email 1")}</Label>
                    <input
                      className={`form-control ${
                        errors.email_1 && "is-invalid"
                      }`}
                      type="text"
                      placeholder={t("email@ejemplo.com")}
                      name="email_1"
                      {...register("email_1", {
                        pattern: {
                          value: /\S+@\S+\.\S+/,
                          message: "El email no es valido",
                        },
                      })}
                    />
                    <InputError errors={errors} name="email_1" />
                  </FormGroup>
                </Col>
              </Row>
            </div>
            <div className="product-group mb-3">
              <Row>
                <Col lg="6">
                  <FormGroup>
                    <Label> {t("Whatsapp 2")}</Label>
                    <input
                      className={`form-control ${
                        errors.whatsapp_2 && "is-invalid"
                      }`}
                      type="text"
                      placeholder="54 9 11 1234-5678"
                      name="whatsapp_2"
                      {...register("whatsapp_2", {
                        pattern: {
                          value: /^\d{1,3}\d{9,13}$/,
                          message:
                            "El whatsapp debe contener solo numeros y debe contener entre 10 y 13 caracteres",
                        },
                      })}
                    />
                    <InputError errors={errors} name="whatsapp_2" />
                  </FormGroup>
                </Col>{" "}
                <Col lg="6">
                  <FormGroup>
                    <Label> {t("Email 2")}</Label>
                    <input
                      className={`form-control ${
                        errors.email_2 && "is-invalid"
                      }`}
                      type="text"
                      placeholder={t("email@ejemplo.com")}
                      name="email_2"
                      {...register("email_2", {
                        pattern: {
                          value: /\S+@\S+\.\S+/,
                          message: "El email no es valido",
                        },
                      })}
                    />
                    <InputError errors={errors} name="email_2" />
                  </FormGroup>
                </Col>
              </Row>
            </div>
            <div className="product-group">
              <Row>
                <Col lg="6">
                  <FormGroup>
                    <Label> {t("Whatsapp 3")}</Label>
                    <input
                      className={`form-control ${
                        errors.whatsapp_3 && "is-invalid"
                      }`}
                      type="text"
                      placeholder="54 9 11 1234-5678"
                      name="whatsapp_3"
                      {...register("whatsapp_3", {
                        pattern: {
                          value: /^\d{1,3}\d{9,13}$/,
                          message:
                            "El whatsapp debe contener solo numeros y debe contener entre 10 y 13 caracteres",
                        },
                      })}
                    />
                    <InputError errors={errors} name="whatsapp_3" />
                  </FormGroup>
                </Col>
                <Col lg="6">
                  <FormGroup>
                    <Label> {t("Email 3")}</Label>
                    <input
                      className={`form-control ${
                        errors.email_3 && "is-invalid"
                      }`}
                      type="text"
                      placeholder={t("email@ejemplo.com")}
                      name="email_3"
                      {...register("email_3", {
                        pattern: {
                          value: /\S+@\S+\.\S+/,
                          message: "El email no es valido",
                        },
                      })}
                    />
                    <InputError errors={errors} name="email_3" />
                  </FormGroup>
                </Col>
              </Row>
            </div>
          </div>
        </CardBody>
      </Card>
    </Fragment>
  );
};
export default ContactData;
